<template>
 <Encabeza>

 </Encabeza>

<v-card class="mx-auto my-3" max-width="100%" elevation="10">
      <v-sheet max-width="350" class="mx-left pa-3">
        <v-form @submit.prevent>
          <div class="row">
            <div class="col">
              <input
                v-model="fecha_inicio"
                type="date"
                class="form-control"
                aria-label="fecha_inicio"
              />
            </div>
            <div class="col mt-2">
              <input
                v-model="fecha_fin"
                type="date"
                class="form-control"
                aria-label="fecha_fin"
              />
            </div>
          </div>


          <v-btn
            @click="buscarPorFechas"
            append-icon="mdi-magnify"
            type="submit"
            color="blue-darken-4"
            block
            class="mt-2 font-weight-bold"
            >CONSULTAR</v-btn
          >
        </v-form>
      </v-sheet>
    </v-card>
  <v-card class="mx-1 my-1 p-4">
    <v-btn
      variant="elevated"
      color="blue-darken-4"
      @click="abrirFormulario(null)"
    >
      Registro Nuevo
    </v-btn>
     <center>  <v-btn
            rounded
            variant="elevated"
            color="red-darken-1"
            @click="generarPDF()"
            >
<v-icon icon="mdi-file-pdf-box"></v-icon>&nbsp;REPORTE PDF</v-btn>  </center> 

    <!-- Utilizar v-data-table para mostrar los registros -->
    <v-data-table :headers="headers" :items="registros" item-key="id">
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon
          @click="abrirDialogo(item)"
          class="m-1"
          color="success"
          icon="mdi-eye"
        >
        </v-icon>
        <v-icon
          @click="abrirFormulario(item)"
          class="m-1"
          color="primary"
          icon="mdi-pencil"
        >
        </v-icon>
      </template>
    </v-data-table>
  </v-card>

  <!-- Formulario -->
  <v-dialog v-model="formularioAbierto" max-width="600">
    <v-card>
      <v-card-title>{{
        modoEdicion ? "Editar Arma" : "Nueva Arma"
      }}</v-card-title>
      <v-card-text>
        <v-form ref="formulario" @submit.prevent="submitForm">
          <v-row>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="formularioArma.codigo_arma"
                label="Código de Arma"
              ></v-text-field>
              <v-text-field
                v-model="formularioArma.tipo_arma"
                label="Tipo de Arma"
              ></v-text-field>
              <v-text-field
                v-model="formularioArma.marca"
                label="Marca del arma"
              ></v-text-field>
              <v-text-field
                v-model="formularioArma.modelo"
                label="Modelo del Arma"
              ></v-text-field>
              <v-text-field
                v-model="formularioArma.seleccion_calibre"
                label="Calibre"
              ></v-text-field>
              <v-text-field
                v-model="formularioArma.cargadores"
                label="Cargadores"
              ></v-text-field>
              <v-text-field
                v-model="formularioArma.pais_procedencia"
                label="País"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="formularioArma.clasificacion"
                label="Clasificación"
              ></v-text-field>
              <v-text-field
                v-model="formularioArma.observaciones"
                label="Observaciones"
              ></v-text-field>
              <v-text-field
                v-model="formularioArma.estado"
                label="Estado"
              ></v-text-field>
              <v-text-field
                v-model="formularioArma.unidad"
                label="Ubicación"
              ></v-text-field>
              <v-text-field
                v-model="formularioArma.primer_responsable"
                label="Primer Responsable"
              ></v-text-field>
              <v-text-field
                v-model="formularioArma.segundo_responsable"
                label="Segundo Responsable"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" @click="submitForm()">{{
          modoEdicion ? "Guardar" : "Registrar"
        }}</v-btn>
        <v-btn color="error" @click="cancelarFormulario">Cancelar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <!-- Modal -->
  <v-dialog v-model="dialogoAbierto" max-width="600">
    <v-card>
      <v-card-title>{{ armaSeleccionada.codigo_arma }}</v-card-title>
      <v-card-text>
         <p><strong>Codigo Arma:</strong> {{ armaSeleccionada.codigo_arma }}</p>        
        <p><strong>Tipo de Arma:</strong> {{ armaSeleccionada.tipo_arma }}</p>
        <p><strong>Clasificación:</strong> {{ armaSeleccionada.clasificacion }}</p>
        <p><strong>Ubicación:</strong> {{ armaSeleccionada.unidad }}</p>
        <p><strong>Responsables:</strong>
          {{ armaSeleccionada.primer_responsable }},
          {{ armaSeleccionada.segundo_responsable }}
        </p>
        <!-- Agrega más detalles según sea necesario -->
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" @click="dialogoAbierto = false">Cerrar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <!-- Alerta -->
  <v-snackbar v-model="snackbarSuccess" color="success">
    {{ snackbarMessage }}
    <template v-slot:action="{ attrs }">
      <v-btn color="white" text v-bind="attrs" @click="snackbarSuccess = false"
        >Cerrar</v-btn
      >
    </template>
  </v-snackbar>
</template>

<script>
import pdfMake from "pdfmake/build/pdfmake";

import ArmaOrganico from "@/services/ArmaOrganico.js";
import { VDataTable } from "vuetify/labs/VDataTable";
import Encabeza from '@/components/EncabezadoPage.vue';
import ReportesRegistro from "@/services/Reportes";

export default {
  components: {
    VDataTable,
    Encabeza,
  },
  data() {
    return {
      registros: [],
      headers: [
        { title: "Código de Arma", value: "codigo_arma" },
        { title: "Tipo de Arma", value: "tipo_arma" },
        { title: "Clasificación", value: "clasificacion" },
        { title: "Ubicación", value: "unidad" },
        { title: "Responsables", value: "primer_responsable" },
        { title: "Acciones", value: "actions", sortable: false },
      ],

      reportes: new ReportesRegistro(),

      dialogoAbierto: false,
      armaSeleccionada: {},
      formularioAbierto: false,
      formularioArma: {
        codigo_arma: "",
        tipo_arma: "",
        marca: "",
        modelo: "",
        seleccion_calibre: "",
        cargadores: "",
        pais_procedencia: "",
        clasificacion: "",
        observaciones: "",
        estado: "",
        unidad: "",
        primer_responsable: "",
        segundo_responsable: "",
        // Agregar más propiedades según sea necesario
      },
      modoEdicion: false,
      snackbarSuccess: false,
      snackbarMessage: "",
    };
  },
  async mounted() {
    try {
      this.registros = await ArmaOrganico.index();
    } catch (error) {
      console.error(error);
    }
  },
  methods: {
    abrirDialogo(arma) {
      this.armaSeleccionada = arma;
      this.dialogoAbierto = true;
    },

    abrirFormulario(arma) {
      if (arma) {
        // Modo edición
        this.formularioArma = { ...arma };
        this.modoEdicion = true;
      } else {
        // Nuevo registro
        this.formularioArma = {
          codigo_arma: "",
          tipo_arma: "",
          marca: "",
          modelo: "",
          seleccion_calibre: "",
          cargadores: "",
          pais_procedencia: "",
          clasificacion: "",
          observaciones: "",
          estado: "",
          unidad: "",
          primer_responsable: "",
          segundo_responsable: "",
          // Agregar más propiedades según sea necesario
        };
        this.modoEdicion = false;
      }
      this.formularioAbierto = true;
    },
    async submitForm() {
      try {
        let response;
        if (this.modoEdicion) {
          // Modo edición: actualizar el registro existente
          //response = await ArmaOrganico.updateForm(this.formularioArma.id);
          response = await ArmaOrganico.updateForm(this.formularioArma.id, this.formularioArma);
          console.log("respuesta a editar",response);
          this.snackbarMessage = "¡El arma se ha actualizado exitosamente!";
        } else {
          // Nuevo registro: crear un nuevo registro
          response = await ArmaOrganico.submitForm(this.formularioArma);
          this.snackbarMessage = "¡El arma se ha guardado exitosamente!";
        }

        // Manejar la respuesta del servidor según sea necesario
        console.log("Respuesta del servidor:", response);

        // Actualizar registros después de guardar o actualizar el arma
        this.registros = await ArmaOrganico.index();

        // Cerrar el formulario después de enviar los datos
        this.formularioAbierto = false;
        this.snackbarSuccess = true;
      } catch (error) {
        console.error("Error al guardar o actualizar el arma:", error);
        // Manejar el error (mostrar mensaje de error, etc.)
      }
    },

    cancelarFormulario() {
      this.formularioAbierto = false;
    },
  },

  async buscarPorFechas() {
      try {
        this.registroslista = await this.reportes.buscarPorFechasArmamento(
          this.fecha_inicio,
          this.fecha_fin
        );
      } catch (error) {
        console.error("Error al buscar por fechas:", error);
        throw error;
      }
    },
   async generarPDF() {
      // Verificar si hay datos para generar el PDF
      if (this.registroslista.length === 0) {
        alert("No hay datos para generar el PDF");
        return;
      }

      // Cargar la imagen como un recurso
      const imagenRecurso = await import("@/assets/images/mindef.jpg");

      // Convertir la imagen en una URL de datos
      const imagenDataURL = await this.convertirImagenDataURL(
        imagenRecurso.default
      );

      // Mapear los registros a un formato adecuado para pdfMake
      const pdfRows = this.registroslista.map((item, index) => {
        return [
          index + 1, // Añade numeración ascendente, comenzando en 1
          item.codigo_arma || "",
          item.tipo_arma || "",
          item.modelo || "",
          item.clasificacion || "",
          item.unidad  || "",
          item.primer_responsable || "",
          item.segundo_responsable || "",        
        ];
      });
      const currentDate = new Date();
      const formattedDate = new Intl.DateTimeFormat("es-ES", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      }).format(currentDate);

      const fechaHora = `FECHA: ${formattedDate}`;
      // Definir la estructura del documento PDF
      const documentDefinition = {
        content: [
          //IMAGEN CABECERA
          {
            image: imagenDataURL, // Usar la URL de datos de la imagen
            width: 200, // ajusta el ancho según tus necesidades
            alignment: "left", // ajusta la alineación según tus necesidades
            margin: [0, 0, 0, 0], // Ancho de la imagen en el PDF
          },
          {
            text: fechaHora, // Agregar la fecha y hora con el formato deseado
            alignment: "left", // Alinear la fecha y hora a la derecha
            fontSize: 8,
            margin: [0, 5, 0, 0],
          },
          {
            text: `FUERZA: ${this.valorCampo3}`, // Agregar la fecha y hora con el formato deseado
            alignment: "left", // Alinear la fecha y hora a la derecha
            fontSize: 8,
            margin: [0, 5, 0, 0],
          },
          {
            text: `REPORTE ARMAMENTO MILITAR`,
            style: "header",
            fontSize: 10,
          },
          /* { text: "Datos obtenidos:", style: "subheader" }, */
          {
            table: {
              headerRows: 1,
              widths: ["auto", "auto", "auto", "auto", "auto", "*"],
              body: [
                [
                  {
                    text: "#",
                    fillColor: "#01579B",
                    bold: true,
                    color: "white",
                    alignment: "center",
                  },
                  {
                    text: "CODIGO ARMA",
                    fillColor: "#01579B",
                    bold: true,
                    color: "white",
                    alignment: "center",
                  },
                  {
                    text: "TIPO ARMA",
                    fillColor: "#01579B",
                    bold: true,
                    color: "white",
                    alignment: "center",
                  },
                   {
                    text: "CLASIFICACION",
                    fillColor: "#01579B",
                    bold: true,
                    color: "white",
                    alignment: "center",
                  },
                       {
                    text: "UNIDAD",
                    fillColor: "#01579B",
                    bold: true,
                    color: "white",
                    alignment: "center",
                  },
                   {
                    text: "PRIMER RESPONSABLE",
                    fillColor: "#01579B",
                    bold: true,
                    color: "white",
                    alignment: "center",
                  },                             
                ],
                ...pdfRows,
              ],
            },
            fontSize: 8,
          },
        ],
        footer: function (currentPage, pageCount) {
          return {
            table: {
              widths: ["*", "auto"],
              body: [
                [
                  {
                    text: "UNIDAD DE SISTEMAS E INFORMÁTICA GESTIÓN 2024",
                    fontSize: 8,
                    alignment: "left",
                  },
                  {
                    text: `Pag. ${currentPage}/${pageCount}`,
                    fontSize: 8,
                    alignment: "right",
                  },
                ],
              ],
            },
            layout: "noBorders", // Para eliminar los bordes de la tabla
            margin: [40, 10], // Margen izquierdo y derecho para centrar la tabla
          };
        },
        styles: {
          header: {
            fontSize: 18,
            alignment: "center",
            bold: true,
            margin: [0, 0, 0, 10],
          },
          subheader: { fontSize: 16, bold: true, margin: [0, 10, 0, 5] },
        },
      };

      // Generar y abrir el PDF
      pdfMake.createPdf(documentDefinition).open();
    },
};
</script>
